import { BaseTheme } from '@famly/mf_theme';
import { OneOffColor, ColorConfiguration } from 'web-app/styleguide/colors';
import { defaultContainerConfiguration } from 'web-app/styleguide/containers';
import { defaultBorderConfiguration } from 'web-app/styleguide/borders';
import { defaultInformationArchitectureConfiguration, } from 'web-app/styleguide/information-architecture';
import { defaultNavigationConfiguration, } from 'web-app/styleguide/navigation-configuration';
import { defaultShadowConfiguration } from 'web-app/styleguide/shadows';
import { defaultFontConfiguration } from 'web-app/styleguide/fonts';
import DefaultTimingConfiguration from 'web-app/styleguide/timings';
import defaultChildDevelopmentConfiguration from '../child-development';
import { DefaultSpacingConfiguration } from '../spacing';
import { defaultChartsConfiguration } from '../charts';
import { defaultButtonConfiguration } from '../components/buttons';
import { defaultElevationConfiguration } from '../elevations';
export const defaultTheme = {
    title: '',
    primary: '',
    secondary: '',
    chromeColor: '',
    active: '',
    accent1: '',
    accent2: '',
    accent3: '',
    analogue1: '',
    analogue2: '',
    analogue3: '',
    analogue4: '',
    text: '',
    blackScrim: '',
    textSecondary: '',
    textDisabled: '',
    invertedText: '',
    invertedTextSecondary: '',
    invertedTextDisabled: '',
    delimiter: '',
    background: '',
    backgroundHover: '',
    applicationBackground: '',
    convertOneOffColor: color => OneOffColor[color],
    shadow: defaultShadowConfiguration,
    fontConfiguration: defaultFontConfiguration,
    buttonConfiguration: defaultButtonConfiguration,
    containerConfiguration: defaultContainerConfiguration,
    borderConfiguration: defaultBorderConfiguration,
    informationArchitectureConfiguration: defaultInformationArchitectureConfiguration,
    chartsConfiguration: defaultChartsConfiguration,
    childDevelopment: defaultChildDevelopmentConfiguration,
    colors: new ColorConfiguration(),
    newColor: (hslColor) => hslColor,
    spacing: DefaultSpacingConfiguration,
    timings: DefaultTimingConfiguration,
    elevation: defaultElevationConfiguration,
    navigationConfiguration: defaultNavigationConfiguration,
    mf: BaseTheme,
};
